import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-calc-settings-dialog',
  standalone: false,
  template: `
    <h2 mat-dialog-title>Calculation Settings</h2>
    <mat-dialog-content style="padding-top: 8px;">
      <mat-form-field appearance="outline" style="width: 100%;">
        <mat-label>Starting Year</mat-label>
        <input matInput type="number" [(ngModel)]="startingYear">
      </mat-form-field>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button (click)="dialogRef.close()">Cancel</button>
      <button mat-flat-button color="primary" style="color: white;" (click)="dialogRef.close(startingYear)">Confirm</button>
    </mat-dialog-actions>
  `
})
export class CalcSettingsDialogComponent {
  startingYear: number;

  constructor(
    public dialogRef: MatDialogRef<CalcSettingsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { startingYear: number }
  ) {
    this.startingYear = data?.startingYear ?? new Date().getFullYear();
  }
}
